import { render, staticRenderFns } from "./NursePatientFiles.vue?vue&type=template&id=28c6ec26&"
import script from "./NursePatientFiles.vue?vue&type=script&lang=js&"
export * from "./NursePatientFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports